import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("+")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Separator = _resolveComponent("Separator")!
  const _component_LayoutRow = _resolveComponent("LayoutRow")!
  const _component_UserInputLabel = _resolveComponent("UserInputLabel")!

  return (_openBlock(), _createBlock(_component_LayoutRow, { class: "status-bar" }, {
    default: _withCtx(() => [
      _createVNode(_component_LayoutRow, { class: "hint-groups" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hintData, (hintGroup, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: hintGroup }, [
              (index !== 0)
                ? (_openBlock(), _createBlock(_component_Separator, {
                    key: 0,
                    type: 'Section'
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hintGroup, (hint) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: hint }, [
                  (hint.plus)
                    ? (_openBlock(), _createBlock(_component_LayoutRow, {
                        key: 0,
                        class: "plus"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_UserInputLabel, {
                    mouseMotion: hint.mouse,
                    keysWithLabelsGroups: _ctx.inputKeysForPlatform(hint)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(hint.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["mouseMotion", "keysWithLabelsGroups"])
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}